import { useTranslation } from 'react-i18next';
import type { ITaskStockClaim } from '@interfaces/IScheduler';
import styles from './TaskPanelStockTab.module.css';
import { ScrollArea } from '@components/ui/ScrollArea/ScrollArea';

interface ITaskPanelStockReadOnlyProps {
  claims: readonly ITaskStockClaim[];
  /** Why the materials can't be booked here, when that is the task's state
   *  (not committed yet) rather than the user's permission. */
  note?: string;
}

/**
 * The Stock tab where nothing can be booked — a user without `tasks.execute`,
 * or a task not committed yet (the server books stock only for a promise,
 * 409 otherwise): the claims as plain text. The tab is where the task's
 * materials are read, so it stays for them — the booking form, cart and
 * checkout (all writes) are not rendered.
 */
export function TaskPanelStockReadOnly({ claims, note }: ITaskPanelStockReadOnlyProps) {
  const { t } = useTranslation();
  return (
    <ScrollArea className={styles.body} viewportClassName={styles.bodyContent}>
      <p className={styles.scope}>{t('scheduler.panel.stock.title')}</p>
      {note && <p className={styles.hint}>{note}</p>}
      {claims.length === 0 ? (
        <p className={styles.hint}>{t('scheduler.panel.stock.empty.title')}</p>
      ) : (
        <ul className={styles.readList}>
          {claims.map((claim) => (
            <li key={claim.id} className={styles.readItem}>
              <bdi>{claim.materialName}</bdi>
              <span className={styles.readQty}>{claim.quantity} {claim.unit}</span>
            </li>
          ))}
        </ul>
      )}
    </ScrollArea>
  );
}
